import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ViewModeProvider } from './contexts/ViewModeContext';
import { ProductProvider } from './contexts/ProductContext';
import { SearchProvider } from './contexts/SearchContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import ProductSidebar from './components/Product/ProductSidebar';
import SpotlightSearch from './components/Search/SpotlightSearch';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import Favorites from './pages/Favorites';
import Settings from './pages/Settings';

function App() {
  return (
    <ProductProvider>
      <ViewModeProvider>
        <SearchProvider>
          <Router>
            <div className="app-grid">
              <Header />
              <main className="app-main">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalog" element={<Catalog />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </main>
              <Footer />
              <ProductSidebar />
              <SpotlightSearch />
            </div>
          </Router>
        </SearchProvider>
      </ViewModeProvider>
    </ProductProvider>
  );
}

export default App;